export default __webpack_public_path__ + "static/media/pop.b7d59387.mp3";